import React, { useEffect } from 'react'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import { gaEvent } from '../../../libraries/utils'

const SuggestNewCarrierFeedback = ({ message }: { message: string }) => {
  const { t } = useTranslation('packages')

  useEffect(() => {
    gaEvent('suggest_new_carrier', 'carriers')
  }, [])

  return (
    <div>
      <p>{message}</p>
      <p>
        <button className="btn btn-dark" onClick={() => toast.info(t('timeline.suggest.toast'))}>
          {t('timeline.suggest.button')}
        </button>
      </p>
    </div>
  )
}

export default React.memo(SuggestNewCarrierFeedback)
